/**
 * WelcomeCard - Welcome banner component for dashboard
 */
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

const WelcomeCard = ({ userName }) => {
  return (
    <Card className="bg-gradient-to-r from-blue-500 to-blue-700 text-white">
      <CardHeader>
        <CardTitle className="text-2xl sm:text-3xl">Welcome back, {userName}!</CardTitle>
        <CardDescription className="text-blue-100">
          Ready to continue your exam preparation journey?
        </CardDescription>
      </CardHeader>
    </Card>
  );
};

export default WelcomeCard;
